"use strict";
/**
 * Created by Pankaj on 2019-12-11.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitBonusController = void 0;
const NolimitBonusView_1 = require("./NolimitBonusView");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const PromoPanelEvents_1 = require("../../events/PromoPanelEvents");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
const Logger_1 = require("@nolimit/slot-launcher/bin/utils/Logger");
class NolimitBonusController {
    constructor(promotionPlugin, data) {
        this._featureData = [];
        this._promotionPlugin = promotionPlugin;
        this._featureData = data;
        this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getAvailableLevels();
    }
    createView(scrollContainer) {
        this._view = new NolimitBonusView_1.NolimitBonusView(this, scrollContainer);
        this._view.createGameFeatureList(this._featureData);
        this.addEventListeners();
    }
    buttonClick(button, featureData, isManualCall = false) {
        Logger_1.Logger.logDev("BuyFeature controller :: onButtonClick", button);
        !isManualCall && NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        switch (button.name) {
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.BET_DOWN:
                this.onBetDownBtnPressed();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.BET_UP:
                this.onBetUpBtnPressed();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.BUY:
                if (featureData == undefined) {
                    Logger_1.Logger.warn("featureData is undefined");
                    return;
                }
                this.onBuyBtnPressed(featureData);
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.OK_BTN:
                this.onPopUpOkBtnPressed(featureData);
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.POP_UP_CLOSE:
                this.onPopUpCloseBtnPressed();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.CLOSE:
                this._promotionPlugin.buttonClick(button);
                break;
            default:
                Logger_1.Logger.warn("Button click : default case : ", button);
        }
    }
    onBetDownBtnPressed() {
        let currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
        let currentBetIndex = this._betLevels.indexOf(currentBetLevel);
        if (currentBetIndex != -1) {
            --currentBetIndex;
            NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.setLevel(this._betLevels[currentBetIndex]);
            this.updateBetButtons(currentBetIndex);
        }
        else {
            Logger_1.Logger.warn("Error invalid bet index : ", currentBetIndex);
        }
    }
    onBetUpBtnPressed() {
        let currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
        let currentBetIndex = this._betLevels.indexOf(currentBetLevel);
        if (currentBetIndex != -1) {
            ++currentBetIndex;
            NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.setLevel(this._betLevels[currentBetIndex]);
            this.updateBetButtons(currentBetIndex);
        }
        else {
            Logger_1.Logger.warn("Error invalid bet index : ", currentBetIndex);
        }
    }
    addEventListeners() {
        NolimitApplication_1.NolimitApplication.events.on(PromoPanelEvents_1.PromoPanelEvents.BALANCE_UPDATE_EVENT, (balance) => this.onBalanceUpdate(balance));
        NolimitApplication_1.NolimitApplication.events.on(PromoPanelEvents_1.PromoPanelEvents.NAV_BUTTON_PRESSED, (buttonId) => this.onNavButtonPressed(buttonId));
    }
    onNavButtonPressed(btnId) {
        if (btnId == PromoPanelButtonIDs_1.PromoPanelButtonIDs.NOLIMIT_BONUS) {
            this.open();
        }
        else {
            this.close();
        }
    }
    onBalanceUpdate(balance) {
        if (this._view) {
            this.setBetLevels();
            this._view.onBalanceUpdate(balance);
        }
    }
    updateBetButtons(currBetIndex) {
        const currentBet = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
        this._view.onBetChange(currentBet);
        this._view.betPanel.betSelector.enableUpButton(false);
        this._view.betPanel.betSelector.enableDownButton(false);
        const minFeaturePrice = this._view.updateFeaturePrice(currentBet);
        const balance = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.balance.getAmount();
        if (currBetIndex < this._betLevels.length - 1 && (+this._betLevels[currBetIndex] < balance) && minFeaturePrice < balance) {
            const nextBetMinFeaturePrice = this.view.getNextBetMinFeaturePrice(this._betLevels[currBetIndex + 1]);
            nextBetMinFeaturePrice <= balance && this._view.betPanel.betSelector.enableUpButton(true);
        }
        if (currBetIndex > 0) {
            this._view.betPanel.betSelector.enableDownButton(true);
        }
    }
    onBuyBtnPressed(featureData) {
        this.view.openPopUp(featureData);
    }
    onPopUpOkBtnPressed(featureData) {
        if (featureData != undefined) {
            NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betHandler.buyFeatureBet(featureData.name);
            this._view.closePopUp();
            this._promotionPlugin.close(true);
        }
    }
    onPopUpCloseBtnPressed() {
        this._view.closePopUp();
    }
    open() {
        this._view.open();
        this.setBetLevels();
        this._view.closePopUp();
    }
    close() {
        this._view.close();
    }
    setBetLevels() {
        this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getAvailableLevels();
        if (this._betLevels.length) {
            let currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
            let currentBetIndex = this._betLevels.indexOf(currentBetLevel);
            currentBetIndex != -1 && this.updateBetButtons(currentBetIndex);
        }
        else {
            this._betLevels = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getUnavailableLevels();
            let currentBetLevel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
            let currentBetIndex = this._betLevels.indexOf(currentBetLevel);
            currentBetIndex != -1 && this.updateBetButtons(currentBetIndex); //TO disable and show default bet and price in promo panel.
        }
    }
    get view() {
        return this._view;
    }
    set view(value) {
        this._view = value;
    }
    get promotionPlugin() {
        return this._promotionPlugin;
    }
}
exports.NolimitBonusController = NolimitBonusController;
//# sourceMappingURL=NolimitBonusController.js.map